import jQuery from 'jquery';
let $ = jQuery;

/**
    * class HSN.ArticleContent
    *
    * Encapsulates the functionality of loading article content within an element.
    * * * Config * * *
    * element: HTMLElement - element to either append or replace
    * appendElement: bool - append element to dom or replace
    **/
HSN.ArticleContent = (function () {
    function ArticleContent(config) {
        config = config || {};
        var __scope = this;
        __scope.element = config.element;
        __scope.appendElement = config.appendElement;
           
        this.Root = $('<div class="ArticleContent"></div>');
        this.Root.hide();

        this.Content = $('<div id="ArticleContent-content"></div>');
        this.Root.append(this.Content);
    }

    /**
        * HSN.ArticleContent#Root -> jQuery
        *
        * [[HSN.ArticleContent#Content]] provides access to the jQuery-wrapped HTML element that is the root of the ArticleContent.
        **/
    ArticleContent.prototype.Root = null;

    /**
        * HSN.ArticleContent#Show() -> void
        *
        * Shows the ArticleContent.
        **/
    ArticleContent.prototype.Show = function (url) {
        var __scope = this;
        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            success: function (data, status, xhr) {
                __scope.Root.removeClass('loading');

                __scope.DisplayContent(data, 0);
            },
            error: function (xhr, status, error) {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
            }
        });
    };

    ArticleContent.prototype.DisplayContent = function (data, time) {
        var scope = this;
        (scope.appendElement) ? scope.element.append(data) : scope.element.html(data);
    };
    return ArticleContent;
})();



// WEBPACK FOOTER //
// ./assets/js/HSN/ArticleContent.js